<h2 mat-dialog-title i18n="@@Move Book">Move Book</h2>
<mat-dialog-content class="mat-typography">
  <p><span i18n="@@Select a new project for">Select a new project for</span><span>&nbsp;</span> <strong>{{ book?.title }}</strong>.</p>
  <div class="flex-column gap-16 mb-20">
    <mat-slide-toggle [(ngModel)]="filterByFolder" (change)="onToggleChange()" color="primary" i18n="@@Filter by Folder">Filter by Folder</mat-slide-toggle>
  </div>

  <div *ngIf="filterByFolder && hasFolders" class="folder-selector-container">
    <label class="tree-label" i18n="@@Select Folder Location">Select Folder Location</label>
    <app-tree-selector [rawData]="{'': folders.getJSON()}" [currentPath]="book?.project?.folder" (nodeSelected)="handleSelection($event)" [excludeNode]="''" [excludeBranch]="''"></app-tree-selector>
  </div>

  <mat-form-field appearance="outline" class="full-width mt-10">
    <mat-label i18n="@@Target Project">Target Project</mat-label>
    <mat-select [(ngModel)]="selectedProject" required>
      <mat-option *ngFor="let proj of filteredProjects" [value]="proj">
        {{ proj.name }}
      </mat-option>
    </mat-select>
    <mat-hint *ngIf="filterByFolder" i18n="@@Showing projects in selected folder">Showing projects in selected folder</mat-hint>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" i18n="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel">Cancel</button>
  <!--
    `selectedProject?.name`, not `.title` — a Project has a `name`, so
    the old binding rendered nothing and the button always read
    "Move <book> to ...". `currentProjectId` guards the same-project
    case without assuming `book.project` is linked.
  -->
  <button mat-raised-button color="primary"
          [disabled]="!selectedProject || selectedProject.ID === currentProjectId || moving"
          (click)="onConfirm($event.target)">
    <span i18n="@@Move">Move</span><span>&nbsp;</span>{{ book?.title }}<span>&nbsp;</span><span i18n="@@to">to</span><span>&nbsp;</span>{{ selectedProject?.name || '…' }}
  </button>
</mat-dialog-actions>
